import { Controller } from '@hotwired/stimulus'

// Shows only the <option>s of this select whose data-<key> equals the value of the source field (route stop hotels
// by the chosen city, CAT-017). The empty option and the selected one always stay; a hidden selected option is
// cleared when the source changes, so a hotel of the old city isn't saved by accident.
export default class OptionFilterController extends Controller<HTMLSelectElement> {
  static override values = { source: String, key: String }
  declare readonly sourceValue: string
  declare readonly keyValue: string

  private source: HTMLSelectElement | null = null
  private readonly onChange = (): void => this.apply(true)

  override connect(): void {
    const element = document.getElementById(this.sourceValue)
    this.source = element instanceof HTMLSelectElement ? element : null
    this.source?.addEventListener('change', this.onChange)
    this.apply(false)
  }

  override disconnect(): void {
    this.source?.removeEventListener('change', this.onChange)
  }

  private apply(sourceChanged: boolean): void {
    const wanted = this.source?.value ?? ''
    for (const option of Array.from(this.element.options)) {
      const matches = option.value === '' || option.getAttribute(`data-${this.keyValue}`) === wanted
      if (!matches && option.selected && sourceChanged) this.element.value = ''
      option.hidden = !matches && !option.selected
    }
  }
}
